<template>
<el-dialog :visible.sync="show" append-to-body title="校验结果" width="410px">
  <div class="content" v-if="rst">
    <div style="padding-bottom: 12px;">以下订单编号为{{ rst.type || '' }}订单，请删除后再进行报单:</div>
    <p v-for="(item, index) in (rst.list || [])" :key="index">{{ item }}</p>
    <div class="color999">注意:{{ rst.type || '' }}订单，请前往{{ rst.type || '' }}报单列表，再进行报单，</div>
  </div>
  <div slot="footer" v-if="cOrderLink">
    <el-button size="mini" @click="$emit('close')">关闭</el-button>
    <el-button
      type="primary"
      size="mini"
      v-clipboard:copy="cOrderLink"
      v-clipboard:success="() => $message.success('复制成功')"
      >一键复制订单编号</el-button>
  </div>
</el-dialog>
</template>

<script>
export default {
  name: 'addResultDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    }, 
    rst: {
      type: Object,
      default: () => ({})
    },
    roleType: {
      type: Number,
      default: null
    },
    reportType: {
      type: String,
      default: ''
    },
  },
  watch: {
    rst: {
      handler () {
        this.cOrderLink = this.rst.list && this.rst.list.length > 0 ? this.rst.list.join('\n') : ''
      },
      immediate: true
    }
  },
  computed: { 
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
  }
}

</script>

<style scoped>
.color999 {
  color: #999;
  font-size: 12px;
  padding-top: 12px;
}
.content {
  line-height: 24px;
}
</style>